export default __webpack_public_path__ + "static/1740-091f67a959062d70d2e4712e272feb9e.gif";